import * as React from 'react';

export interface SidebarHeaderProps {
  children?: React.ReactNode;
  dataHook?: string;
  title?: React.ReactNode;
  subtitle?: React.ReactNode;
}

export default class SidebarHeader extends React.PureComponent<SidebarHeaderProps> {}
